import { render, staticRenderFns } from "./SupportTicketForm.vue?vue&type=template&id=9f91b990&"
import script from "./SupportTicketForm.vue?vue&type=script&lang=js&"
export * from "./SupportTicketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports